module.exports = __webpack_public_path__ + "static/media/plant01.2310cd5e.svg";